// src/forwardRef.tsx
import {
  forwardRef as forwardRefReact
} from "react";
function forwardRef(component) {
  return forwardRefReact(component);
}

// src/polymorphic-factory.tsx
import { jsx } from "react/jsx-runtime";
function defaultStyled(originalComponent) {
  return forwardRef((props, ref) => {
    const { as, ...restProps } = props;
    const Component = as || originalComponent;
    return /* @__PURE__ */ jsx(Component, { ...restProps, ref });
  });
}
function polymorphicFactory({ styled = defaultStyled } = {}) {
  const cache = /* @__PURE__ */ new Map();
  return new Proxy(styled, {
    /**
     * @example
     * const Div = poly("div")
     * const WithPoly = poly(AnotherComponent)
     */
    apply(target, thisArg, argArray) {
      return styled(...argArray);
    },
    /**
     * @example
     * <poly.div />
     */
    get(_, element) {
      const asElement = element;
      if (!cache.has(asElement)) {
        cache.set(asElement, styled(asElement));
      }
      return cache.get(asElement);
    }
  });
}
export {
  forwardRef,
  polymorphicFactory
};
